import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將 yyyyMMdd 格式（例如：20260505）轉成 MM/dd（例如：05/05）
 */
@Pipe({
  name: 'formatDateMMDD',
  standalone: true,
})
export class FormatDateMMDDPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value || value.length !== 8) {
      return '待安排';
    }
    if (!/^\d{8}$/.test(value)) {
    return '';
    }

    const month = value.slice(4, 6);
    const day = value.slice(6, 8);

    return `${month}/${day}`;
  }
}